import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import HugeLogo from "../images/h.svg";
import DumpsterFire from "../images/DumpsterFire.svg";

export default class Hero extends Component {
  render() {
    return (
      <div className="flex pt-10 pb-20 justify-between items-center">
        <div className="text-left h6">
          <a
            className="transition-colors duration-200 hover:text-hugeorange"
            href="//hugeinc.com"
          >
            Huge Inc.
          </a>
        </div>
        <div className="text-center">
          <Link to="/">
            <img
              src={HugeLogo}
              className="text-white logo hover:text-hugeorange"
              onMouseOver={(e) => (e.currentTarget.src = DumpsterFire)}
              onMouseOut={(e) => (e.currentTarget.src = HugeLogo)}
              alt="logo"
            />
          </Link>
        </div>
        <div className="text-right h6">
          <NavLink
            className="transition-colors duration-200 hover:text-hugeorange"
            activeClassName="text-hugeorange line-through"
            to="/archive"
          >
            Archive
          </NavLink>
        </div>
      </div>
    );
  }
}
